  // For custom page size dropdown
  
import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { LoginLogsService, LoginLogsDTO, LoginLogDetailsDTO } from './loginLogs/login-logs.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { FormGroup } from '@angular/forms';

interface AuditLog {
  logId: string;
  operationType: string;
  entityName: string;
  changes: Record<string, any>;
  userId: string;
  timestamp: number;
}

interface UserSession {
  id: string;
  name: string;
  email: string;
  avatarUrl: string;
  status: string;
  currentActivity?: string;
  sessionDuration?: string;
  device?: string;
  location?: string;
  lastLogin?: string;
  ip?: string;
  logs?: AuditLog[];
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  private loggedIn = new BehaviorSubject<boolean>(false);
  @Output() toggleClick = new EventEmitter<void>();
  form!: FormGroup;
  selectedMenu: string = 'interview-codes';
  searchText: string = '';
  searchTimeout: any;
visiblePageCount = 10;
paginationPages: (number | string)[] = [];

  onSearchChange(event: any) {
  const value = event.target.value.trim();
  this.searchText = value;
  if (this.searchTimeout) {
    clearTimeout(this.searchTimeout);
  }
  this.searchTimeout = setTimeout(() => {
    if (!value) {
      this.fetchLoginLogs();
      return;
    }
    this.loginLogsService.searchLoginLogs({ userName: value }, this.logsPage, this.logsSize).subscribe((response: any) => {
      this.logs = response?.content || [];
      this.logsTotalPages = response?.totalPages || 1;
      this.logsTotalElements = response?.totalElements || this.logs.length;

      this.logs.forEach(log => {
        if (log.loginUserId && !this.logUsers[log.loginUserId]) {
          const user = this.usersMap[log.loginUserId];
          this.logUsers[log.loginUserId] = {
            name: user?.name || (user?.firstName ? user.firstName + (user.lastName ? ' ' + user.lastName : '') : '-') || '-',
            email: user?.email || '-',
            device: user?.device || '-',
            location: user?.location || '-'
          };
        }
      });
    }, () => {
      this.fetchLoginLogs();
    });
  }, 400); // debounce
}

  selectedStatus: string = '';
  selectedDate: string = '';
filterDate: string = '';
filterStatus: string = '';
sortOption: string = '';

statusList = ['Active', 'Idle', 'Inactive'];

  userSessions: UserSession[] = [];
  filteredSessions: UserSession[] = [];
  selectedUser: LoginLogDetailsDTO | null = null;
  selectedUserLoading: boolean = false;
  isMobile: boolean = false;
  menuOpen: boolean = true;
  mobileMenuOpen: boolean = false;
  selectedPrompt: any = null;
  logs: LoginLogsDTO[] = [];
  get sortedLogs(): LoginLogsDTO[] {
    return [...this.logs].sort((a, b) => (b.loginTime || 0) - (a.loginTime || 0));
  }
  logUsers: { [userId: string]: { name: string; email: string; device: string; location: string } | undefined } = {};
  usersMap: { [userId: string]: any } = {};
  logsPage = 0;
  logsSize = 10;
  logsTotalPages = 1;
  logsTotalElements = 0;
  logsLoading = false;

  constructor(
    private loginLogsService: LoginLogsService,
    private http: HttpClient,
       private router: Router,
      private authService: AuthService
  ) {}
  isDropdownOpen = false;
  


    

  clearSelection(): void {
    this.selectedPrompt = null;
    this.form.reset();
  }
  pageSizeOptions = [ 10, 30, 50];
  pageSizeDropdownOpen = false;

  togglePageSizeDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.pageSizeDropdownOpen = !this.pageSizeDropdownOpen;
  }

  selectPageSize(size: number, event: MouseEvent) {
    event.stopPropagation();
    this.logsSize = size;
    this.logsPage = 0;
    this.pageSizeDropdownOpen = false;
    this.fetchLoginLogs();
  }

  changePageSize(size: number) {
    this.logsSize = size;
    this.logsPage = 0;
    this.pageSizeDropdownOpen = false;
    this.fetchLoginLogs();
  }

  // Close dropdown on outside click
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown') && !target.closest('.page-size-select')) {
      this.pageSizeDropdownOpen = false;
    }
  }

   logout(): void {
    this.loggedIn.next(false); // Broadcast that the user is logged out
    const loginLogId = sessionStorage.getItem('loginLogId');
    if (loginLogId) {
      this.loginLogsService.logUpdate(loginLogId, () => {
        this.authService.signOut();
      });
    } else {
      this.authService.signOut();
    }
  }

  ngOnInit(): void {
    this.menuOpen = true;
    this.checkScreenSize();
    window.addEventListener('resize', () => {
      this.checkScreenSize();
      if (this.isMobile) {
        this.menuOpen = false;
      }
    });
    this.authService.getAllUsers().subscribe((users: any) => {
      if (Array.isArray(users)) {
        users.forEach((user: any) => {
          this.usersMap[user.id] = user;
        });
      }
    }, () => {
      // Error fetching users - continue without user mapping
    });
  }

  // Method to handle menu selection and lazy load activity logs
  onMenuSelect(menu: string): void {
    this.selectedMenu = menu;
    if (this.isMobile) {
      // Close menu after selection for mobile
      setTimeout(() => {
        this.menuOpen = false;
      }, 150);
    }
    if (menu === 'dashboard') {
      this.logsPage = 0; // Reset to first page when switching tabs
      this.fetchLoginLogs();
    }
  }
displayPage(p: number | string): string {
  return p === '...' ? '...' : String((p as number) + 1);
}

fetchLoginLogs() {
  this.logsLoading = true;
  this.loginLogsService
    .getAllLoginLogs(this.logsPage, this.logsSize)
    .subscribe(
      (response: any) => {
        this.logs = response?.content || [];
        this.logsTotalPages = response?.totalPages || 1;
        this.logsTotalElements = response?.totalElements || this.logs.length;

        this.updatePagination();

        this.logs.forEach(log => {
          if (log.loginUserId && this.usersMap[log.loginUserId]) {
            const user = this.usersMap[log.loginUserId];
            this.logUsers[log.loginUserId] = {
              name: user?.name || user?.firstName || '-',
              email: user?.email || '-',
              device: user?.device || '-',
              location: user?.location || '-'
            };
          } else {
            this.logUsers[log.loginUserId] = {
              name: '-',
              email: '-',
              device: '-',
              location: '-'
            };
          }
        });

        this.logsLoading = false;
      },
      () => (this.logsLoading = false)
    );
}
  cleanLocation(loc: string): string {
    if (!loc) return '';
    // Split by comma, trim each part, remove empty, join back
    return loc
      .split(',')
      .map(part => part.trim())
      .filter(part => part.length > 0)
      .join(', ');
  }
updatePagination() {
  const total = this.logsTotalPages;
  const current = this.logsPage;
  const visible = this.visiblePageCount;

  const pages: (number | string)[] = [];

  if (total <= visible + 2) {
    // Small page count → show all
    for (let i = 0; i < total; i++) {
      pages.push(i);
    }
    this.paginationPages = pages;
    return;
  }

  // Always show first page
  pages.push(0);

  let start = Math.max(1, current - Math.floor(visible / 2));
  let end = start + visible - 1;

  // Adjust if exceeding last page
  if (end >= total - 1) {
    end = total - 2;
    start = end - visible + 1;
  }

  // Ellipsis after first
  if (start > 1) {
    pages.push('...');
  }

  // Middle pages (10 numbers)
  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  // Ellipsis before last
  if (end < total - 2) {
    pages.push('...');
  }

  // Always show last page
  pages.push(total - 1);

  this.paginationPages = pages;
}


goToPage(page: number | string) {
  if (page === '...' || page === this.logsPage) return;
  this.logsPage = page as number;
  this.fetchLoginLogs();
}

  formatTimestamp(ts: number): string {
    if (!ts) return '-';
    const date = new Date(ts);
    return date.toLocaleString();
  }

  // nextLogsPage() {
  //   if (this.logsPage < this.logsTotalPages - 1) {
  //     this.fetchLogs(this.logsPage + 1);
  //   }
  // }

  // prevLogsPage() {
  //   if (this.logsPage > 0) {
  //     this.fetchLogs(this.logsPage - 1);
  //   }
  // }

  filterSessions() {
    let filtered = [...this.userSessions];
    if (this.searchText.trim()) {
      filtered = filtered.filter(x =>
        x.name?.toLowerCase().includes(this.searchText.toLowerCase()) ||
        x.email?.toLowerCase().includes(this.searchText.toLowerCase())
      );
    }
    if (this.selectedStatus) {
      filtered = filtered.filter(x => x.status === this.selectedStatus);
    }
    if (this.selectedDate) {
      filtered = filtered.filter(x => x.lastLogin?.includes(this.selectedDate));
    }
    return filtered;
  }

  viewUserAudit(log: LoginLogsDTO) {
    if (!log.id) {
      console.error('Login log ID is missing');
      return;
    }
    this.selectedUserLoading = true;
    this.loginLogsService.getLoginLogDetailsById(log.id).subscribe(
      (details: LoginLogDetailsDTO) => {
        this.selectedUser = details;
        this.selectedUserLoading = false;
      },
      (error) => {
        console.error('Failed to fetch login log details:', error);
        this.selectedUserLoading = false;
      }
    );
  }

  handleAuditBack() {
    this.selectedUser = null;
  }
toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  toggleMenu() {
    // For mobile, add a slight delay for smoothness
    if (this.isMobile) {
      if (this.menuOpen) {
        setTimeout(() => {
          this.menuOpen = false;
        }, 150); // smooth close
      } else {
        this.menuOpen = true;
      }
    } else {
      this.menuOpen = !this.menuOpen;
    }
  }

  toggleSidebar() {
    this.toggleClick.emit()
  }

  @HostListener('window:resize')
  
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 1080;
      if (this.isMobile && this.menuOpen) {
        this.menuOpen = false;
      }
    }

    applyFilters() {
  let data = [...this.userSessions];

  // Search (name + email)
  if (this.searchText.trim()) {
    const text = this.searchText.toLowerCase();
    data = data.filter(s =>
      s.name.toLowerCase().includes(text) ||
      s.email.toLowerCase().includes(text)
    );
  }

  // Filter by date
  if (this.filterDate) {
    data = data.filter(s => s.lastLogin === this.filterDate);
  }
   // Status filter
  if (this.filterStatus) {
    data = data.filter(s => s.status === this.filterStatus);
  }

  // Sorting
  switch (this.sortOption) {
    case 'name-asc':
      data.sort((a, b) => a.name.localeCompare(b.name));
      break;
    case 'name-desc':
      data.sort((a, b) => b.name.localeCompare(a.name));
      break;
    case 'login-new':
      data.sort((a, b) => 
        new Date(b.lastLogin ?? '').getTime() - new Date(a.lastLogin ?? '').getTime()
      );
      break;
    case 'login-old':
      data.sort((a, b) => 
        new Date(a.lastLogin ?? '').getTime() - new Date(b.lastLogin ?? '').getTime()
      );
      break;
    case 'active':
      data.sort((a, b) => (a.status === 'Active' ? -1 : 1));
      break;
  }

  this.filteredSessions = data;
}
}